import * as React from 'react';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import { shadow } from '@core-ds/primitives';

const LightTippy = styled(Tippy)`
   min-width: 200px;
   color: black;
   box-shadow: ${shadow[3]};
   padding: 0;
   border-radius: 8px;
   overflow: auto;
   background-color: white;

   .tippy-content {
      display: flex;

      > div {
         flex: 1 1 auto;
      }
   }
`;

const noop = () => {};

interface WrappedProps {
   id: string;
   href: string;
   onClick: React.MouseEventHandler;
   onKeyDown: React.KeyboardEventHandler;
   children: React.ReactNode;
}

function withTippy<ClickableElementProps>(
   ClickableElement: React.ComponentType<WrappedProps & ClickableElementProps>
) {
   type ResultProps = {
      children: React.ReactNode;
      id?: string;
      clickableElementProps?: ClickableElementProps;
   } & Omit<React.ComponentProps<typeof Tippy>, 'children' | 'id'>;
   return ({
      onMount,
      content,
      children,
      id,
      clickableElementProps,
      ...tippyOptions
   }: ResultProps) => {
      return (
         <LightTippy
            trigger="click"
            duration={200}
            interactive
            placement="bottom-end"
            popperOptions={{ modifiers: [{ name: 'flip', enabled: false }] }}
            onMount={onMount || noop}
            content={content}
            appendTo="parent"
            {...tippyOptions}
         >
            <ClickableElement
               {...clickableElementProps}
               id={id}
               href="#"
               onClick={e => e.stopPropagation()}
               onKeyDown={e => e.stopPropagation()}
            >
               {children}
            </ClickableElement>
         </LightTippy>
      );
   };
}

export default withTippy;
